import { GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getTransactionsBatch({ commit }, { filters = {} }) {
    commit('toggleLoading', true);
    commit('toggleHasNoResult', true);
    const {
      search_by: search_by = 'order_number',
      search_values: search_values = [],
    } = filters;

    const params = {
      search_by,
      search_values,
    };

    const query = `
    query (
      $search_by: String,
      $search_values: [String],
    ) {
      secure_order_batch (
        search_by: $search_by,
        search_values: $search_values,
      ) {
        total
        esprinter_orders {
          so_id
          created_date
        }
        lookup_orders {
          so_id
          created_date
        }
        items {
          number
          end_customer_full_name
          end_customer_city
          end_customer_uf
          invoice
          dm_name
          dispached_date
          estimated_delivery_date
          estimated_lp_delivery_date
          performance { code localized }
          performance_lp { code localized }
          macro_state { code localized }
          marketplace_order_number
        }
      }
    }`;

    return GraphQlClient.query(query, params)
      .then(({ data = {} }) => {
        const { secure_order_batch = [] } = data;
        const {
          items = [],
          total = 0,
          esprinter_orders = [],
          lookup_orders = [],
        } = secure_order_batch;

        commit('toggleLoading', false);
        commit('setTransactionsBatch', items);
        commit('setTransactionsBatchTotal', total);
        commit('setTransactionsBatchEsprinterOrders', esprinter_orders);
        commit('setTransactionsBatchLookupOrders', lookup_orders);
        if (total > 0) commit('toggleHasNoResult', false);
        return Promise.resolve(secure_order_batch);
      })
      .catch((err) => {
        commit('toggleHasNoResult', true);
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  exportTransactionsBatch({ commit }, {
    transactionsBatchLookupOrders: lookup,
    transactionsBatchEsprinterOrders: esprinter,
    filters,
  }) {
    commit('toggleLoadingExport', true);

    const params = {
      lookup_orders: lookup || [],
      esprinter_orders: esprinter || [],
      search_by: filters.search_by || 'order_number',
      search_values: filters.search_values || [],
    };

    const mutation = `
    mutation (
      $lookup_orders: [OrderIdInput],
      $esprinter_orders: [OrderIdInput],
      $search_by: String,
      $search_values: [String],
    ) {
      orderBatchExport (
        lookup_orders: $lookup_orders,
        esprinter_orders: $esprinter_orders,
        search_by: $search_by,
        search_values: $search_values,
      ) {
        ok
      }
    }`;

    return GraphQlClient.mutation(mutation, params)
      .then((res) => {
        commit('toggleLoadingExport', false);
        ScToast.success('O arquivo de relatório está sendo gerado, em instantes estará disponível na seção "Meus Arquivos".');

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoadingExport', false);
        ScToast.danger('Falha ao gerar relatório.');
        return Promise.reject(err);
      });
  },
  getShipmentOrderList({ commit }, params) {
    commit('toggleLoading', true);
    return GraphQlClient.query(`
      query {
        trackingUpdateOrderList {
          orders,
        }
      }`, { params })
      .then((res) => {
        const { data = {} } = res || {};
        const { trackingUpdateOrderList = {} } = data || {};
        const { orders = [] } = trackingUpdateOrderList || {};

        commit('toggleLoading', false);
        return Promise.resolve(orders);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transactions-batch/store/actions.js